import moment, { Moment } from 'moment-timezone';

interface TimespanConfig {
  interval: number;
  showHalfHours: boolean;
}

export function calculateTimeIntervals(startDateTime: Moment, endDateTime: Moment): TimespanConfig {
  const timeSpan = moment(endDateTime).diff(moment(startDateTime), 'hours');
  let interval = 1; // Default to 1 hour
  let showHalfHours = false;
  
  // Adjust interval based on timespan
  if (timeSpan < 24) {
    interval = 1; // Show every hour
    showHalfHours = true; // Show half hours for short timespans
  } else if (timeSpan === 24) {
    interval = 1; // Show every hour for exactly 24 hours
    showHalfHours = false;
  } else if (timeSpan <= 72) { // 3 days
    interval = 3; // Show every 3 hours
  } else if (timeSpan <= 168) { // 1 week
    interval = 6; // Show every 6 hours
  } else if (timeSpan <= 720) { // 30 days
    interval = 12; // Show every 12 hours
  } else {
    interval = 24; // Show once per day
  }

  return { interval, showHalfHours };
}

export function formatTimeLabel(timestamp: Moment, showHalfHours: boolean): string {
  return showHalfHours ? timestamp.format('h:mm A') : timestamp.format('h A');
}

export function shouldShowTimeLabel(
  timestamp: Moment, 
  startDateTime: Moment, 
  interval: number, 
  showHalfHours: boolean
): boolean {
  // For half hours, show every 30 minutes
  if (showHalfHours) {
    return timestamp.minute() === 0 || timestamp.minute() === 30;
  }
  
  // For full hours, show based on interval
  if (timestamp.minute() !== 0) return false;
  
  // Calculate how many hours from the start
  const hoursFromStart = timestamp.diff(moment(startDateTime), 'hours');
  return hoursFromStart % interval === 0;
} 